import React from 'react'
import { Placeholder } from 'semantic-ui-react'

const PlaceholderExampleImage = () => (
  <Placeholder style={{ height: 150, width: 150, borderRadius: 100}}>
    <Placeholder.Image />
  </Placeholder>
  
)

export default PlaceholderExampleImage
